import { type Path, type Control } from 'react-hook-form';
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '../ui/form';
import { Input } from '../ui/input';
import { type InputHTMLAttributes } from 'react';
import { cn } from '~/lib/utils';

export type FormInputProps<T extends object> = {
  control: Control<T>;
  id: string;
  name: Path<T>;
  label?: string;
  placeholder?: string;
  description?: string;
  disabled?: boolean;
  type?: InputHTMLAttributes<HTMLInputElement>['type'];
  className?: string;
  optional?: boolean;
};

export function FormInput<T extends object>(props: FormInputProps<T>) {
  return (
    <FormField
      disabled={props.disabled}
      control={props.control}
      name={props.name}
      render={({ field, fieldState }) => (
        <FormItem className={props.className}>
          {props.label && (
            <FormLabel optional={props.optional}>{props.label}</FormLabel>
          )}
          <FormControl>
            <Input
              placeholder={props.placeholder}
              type={props.type}
              className={cn({
                'border-destructive': fieldState.error,
              })}
              {...field}
            />
          </FormControl>
          {props.description && (
            <FormDescription>{props.description}</FormDescription>
          )}
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
